var map = {
	"./subdir/tmpl": 12,
	"./subdir/tmpl.js": 12,
	"./templateLoader": 8,
	"./templateLoader.js": 8,
	"./templateLoaderIndirect": 9,
	"./templateLoaderIndirect.js": 9,
	"./tmpl": 10,
	"./tmpl.js": 10,
	"xyz": 13,
	"xyz.js": 13
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;



/*****************
 ** WEBPACK FOOTER
 ** ./parsing/context/templates .
 ** module id = 2
 ** module chunks = 0
 **/